export default __webpack_public_path__ + "static/media/electricityImg.a3300f74.PNG";